import { Injectable } from '@angular/core';
declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class LsHelperService {

  constructor() { }

  set(key: any, value: any){
  	window.localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: any){
  	var data = window.localStorage.getItem(key);

  	return JSON.parse(data)
  }
}
